import { render, staticRenderFns } from "./BmsMonitor.vue?vue&type=template&id=11834328&scoped=true"
import script from "./BmsMonitor.vue?vue&type=script&lang=js"
export * from "./BmsMonitor.vue?vue&type=script&lang=js"
import style0 from "./BmsMonitor.vue?vue&type=style&index=0&id=11834328&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11834328",
  null
  
)

export default component.exports